module.exports = __webpack_public_path__ + "static/UAmobSlide8-4325ee189284aeba7c68983e6336bbbf.jpg";